import Vue from 'vue';
import Vue2Filters from 'vue2-filters'
import moment from 'moment'

Vue.use(Vue2Filters);



Vue.filter('currencyNoDecimal', function (value:number) {
    return Vue.filter('currency')(value, '', 0, { thousandsSeparator: ' ', decimalSeparator: ',' });
});

Vue.filter('currencyDecimal', function (value:number) {
    return Vue.filter('currency')(value, '', 2, { thousandsSeparator: ' ', decimalSeparator: ',' });
});

Vue.filter('shortDate', function (value:string) {
    return moment(value).format("D MMM.");
});

Vue.filter('shortTime', function (value:string) {
    return moment(value).format("HH:mm");
});

Vue.filter('shortDateTime', function (value:string) {
    return moment(value).format("D MMM. HH:mm");
});

Vue.filter('date', function (value:string) {
    return moment(value).format("DD MMMM YYYY");
});

Vue.filter('dateDayShort', function (value:string) {
    return moment(value).format("dd.");
});

Vue.filter('numberToPercent', function (value:number) {
    value = Math.round(value);
    if (value < 0) value = 0;
    if (value > 100) value = 100;
    return ''+value+'%';
});

